import { PlatformKeyCode } from "$modules/expo-tv-connect";
import CustomPlatform from "$src/core/utils/platform/platform";

/** Whether this platform can host a tv-connect session. The Android module is a stub. */
export const IS_TV_CONNECT_HOST_SUPPORTED = CustomPlatform.select({
  androidTV: false,
  tv: true,
  default: false,
});

const TV_CONNECT_DPAD_KEYS = [
  PlatformKeyCode.Up,
  PlatformKeyCode.Down,
  PlatformKeyCode.Left,
  PlatformKeyCode.Right,
  PlatformKeyCode.Enter,
] as const;

/** Whether the host's `supportedKeys` include full D-pad navigation. */
export const hasTvConnectDpadSupport = (supportedKeys?: PlatformKeyCode[]) =>
  !!supportedKeys &&
  TV_CONNECT_DPAD_KEYS.every((key) => supportedKeys.includes(key));

/** Default seek step for TV remote controls, in seconds. */
export const TV_CONNECT_SEEK_STEP_S = 30;

/** Interval for extrapolating playback progress while playing */
export const TV_CONNECT_PLAYBACK_TICK_MS = 1_000; // 1 second

/** How long the host's "device connected" toast stays on screen. */
export const TV_CONNECT_CONNECTED_TOAST_MS = 3_000;
